import { useRef } from "react"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"
import React from "react"
import { MdDownload } from "react-icons/md"
import logo from "../../assets/images/logo.jpg"
import Signature from "../../assets/images/Signature.png"
import Configs from "../../config"
import html2pdf from "html2pdf.js"

const ContractPDF = ({ isOpen, toggle, location }) => {
  const printref = useRef(null)

  const handleDownload = () => {
    const element = printref.current

    if (!element) return

    const options = {
      margin: [10, 10, 10, 10],
      filename: `${location?.name || "contract"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2, // 🔥 sharp text
        useCORS: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
      pagebreak: {
        mode: ["avoid-all", "css", "legacy"], // prevent cut content
      },
    }

    html2pdf().set(options).from(element).save()
  }

  return (
    <Modal isOpen={isOpen} centered size="xl">
      <ModalHeader toggle={() => toggle(false)}>
        <div className="d-flex justify-content-between align-items-center w-100">
          <h3 className="mb-0">{location?.name}'s Contract</h3>
          <Button
            color="info"
            className="ms-5"
            onClick={() => handleDownload()}
          >
            <MdDownload /> Download
          </Button>
        </div>
      </ModalHeader>
      <ModalBody className="bg-white">
        <div
          className="contract-content px-3"
          ref={printref}
          style={{
            maxHeight: "90vh",
            overflowY: "scroll",
            scrollbarWidth: "thin",
          }}
        >
          <div className="d-flex justify-content-center mb-4">
            <img src={logo} className="object-fit-cover " width={200}></img>
          </div>
          <div
            className=""
            dangerouslySetInnerHTML={{ __html: location?.contract }}
          ></div>
          <div className="d-flex justify-content-between ">
            <div>
              <img
                src={Signature}
                className="object-fit-cover border-bottom border-dark pb-2"
                width={150}
                height={80}
              ></img>
              <h5 className="fw-bold mb-1 mt-2">Joseph Kyle</h5>
              <h6 className="mb-1">Director </h6>
              <h6>For J Kyle Cleaning Services</h6>
            </div>
            <div>
              <img
                src={
                  location?.signature
                    ? `${Configs.imageUrl}${location?.signature}`
                    : ""
                }
                className="object-fit-cover border-bottom border-dark pb-2"
                width={150}
                height={80}
              ></img>
              <h5 className="fw-bold mb-1 mt-2">{location?.contactPerson}</h5>
              <h6>For {location?.name}</h6>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ContractPDF
